// ============================================================================
// Registro (log) da tela no desktop.
// ----------------------------------------------------------------------------
// No desktop, os erros da tela vão para o mesmo arquivo de registro do Rust
// (apps/desktop/src/registro.rs → ~/.local/share/com.getsinapse.desktop/logs/
// sinapse.log). Na web não há arquivo: vira no-op.
// Nunca passar token, senha ou conteúdo de nota por aqui — só o que ajuda a
// entender uma falha.
// ============================================================================
import { isTauri } from './diskvault'

export type Nivel = 'info' | 'aviso' | 'erro'

export function registrar(nivel: Nivel, origem: string, mensagem: string): void {
  if (!isTauri()) return
  void import('@tauri-apps/api/core')
    .then(({ invoke }) => invoke('registrar_log', { nivel, origem, mensagem }))
    .catch(() => {})
}

function descrever(e: unknown): string {
  if (e instanceof Error) return `${e.name}: ${e.message}${e.stack ? ` | ${e.stack}` : ''}`
  try {
    return typeof e === 'string' ? e : JSON.stringify(e)
  } catch {
    return String(e)
  }
}

/** Liga a captura de erros não tratados da tela. Chamar uma vez no boot. */
export function ligarRegistroDeErros(): void {
  if (!isTauri()) return
  window.addEventListener('error', (ev) => {
    const onde = ev.filename ? ` (${ev.filename}:${ev.lineno}:${ev.colno})` : ''
    registrar('erro', 'window', `${ev.error ? descrever(ev.error) : ev.message}${onde}`)
  })
  window.addEventListener('unhandledrejection', (ev) => {
    registrar('erro', 'promessa', descrever(ev.reason))
  })
  registrar('info', 'boot', `tela carregada — ${navigator.userAgent}`)
}
